import { render, staticRenderFns } from "./situationDetail.vue?vue&type=template&id=5eb5953a&scoped=true"
import script from "./situationDetail.vue?vue&type=script&lang=js"
export * from "./situationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb5953a",
  null
  
)

export default component.exports